export const style = [
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "poi",
    stylers: [{ visibility: "off" }]
  }
];



// WEBPACK FOOTER //
// ./src/components/Site/Map/style.js